import React from "react"

const Head = () => {
  return (
    <>
      <section className='head'>
        <div className='container flexSB'>
          <div className='logo'>
            <h1>VARLC</h1>
            <span>ACADEMICS, SCHOLARSHIPS & COMPETITIONS</span>
          </div>

          <div className='social'>
            <i className='fab fa-whatsapp icon'></i>
          </div>
        </div>
      </section>
    </>
  )
}

export default Head
